import * as React from "react";

function FileConfigIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "44 8 44 16 52 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52 16 44 8 12 8 12 56 52 56 52 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32a11.49 11.49 0 0 0-.16-1.95L40 28.69 41.75 25A12 12 0 0 0 39 22.25L35.31 24 34 20.16a12 12 0 0 0-3.9 0L28.69 24 25 22.25A12 12 0 0 0 22.25 25L24 28.69l-3.84 1.36a12 12 0 0 0 0 3.9L24 35.31 22.25 39A12 12 0 0 0 25 41.75L28.69 40l1.36 3.84a12 12 0 0 0 3.9 0L35.31 40 39 41.75A12 12 0 0 0 41.75 39L40 35.31 43.84 34a11.49 11.49 0 0 0 .16-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 2
  }));
}

export default FileConfigIcon;